/*global EventAggregationService */

import { SessionCreatedEvent, SessionDestroyedEvent, SessionServiceReadyEvent } from '@studyportals/student-interfaces';

export class SnowplowUserIdentifierService {
	constructor(snowPlowTracker) {
		this.snowPlowTracker = snowPlowTracker;
	}

	loadStudentIdentityId() {
		if (typeof window['IdentityId'] === 'string') {
			this.snowPlowTracker.setUserId(window['IdentityId']);
		}

		this.subscribeToSessionService();
	}

	async subscribeToSessionService() {
		if (typeof EventAggregationService !== 'object') {
			this.snowPlowTracker.trackServiceUnavailable('EventAggregationService');
			return;
		}

		EventAggregationService.subscribeTo(
			SessionServiceReadyEvent.EventType,
			{
				notify: async (event) => {
					await this.onSessionServiceReady(event.sessionService);
				}
			},
			true
		);

		EventAggregationService.subscribeTo(SessionCreatedEvent.EventType, {
			notify: (sessionCreatedEvent) => {
				this.setUserIdBasedOnSession(sessionCreatedEvent.session);
			}
		});

		EventAggregationService.subscribeTo(SessionDestroyedEvent.EventType, {
			notify: () => {
				this.snowPlowTracker.clearUserId();
			}
		});
	}

	async onSessionServiceReady(sessionService) {
		const session = await sessionService.getSession();
		if (session !== null) {
			this.setUserIdBasedOnSession(session);
		}
	}

	setUserIdBasedOnSession(session) {
		if (session === null || session === undefined) {
			return;
		}

		const identityId = session.getUser().identityId;
		this.snowPlowTracker.setUserId(identityId);
	}
}
